import bootbox from 'bootbox';
import Sortable from 'sortablejs';

$(document).ready(function()
{
  if ($("#btnSettingsPageNew").length === 0) return;

  Sortable.create(document.getElementById("tbodySettingsPages"),
  {
    animation: 200,
    draggable: ".trPage",
    handle: ".tdPageSort",
    onEnd: function(e)
    {
      let $tbody = $(e.target)

      let params = {};
      
      $tbody.find(".trPage").each(function(i)
      {
        let $tr = $(this);
        params[$tr.data("id")] = {
          'order_page': i
        };
      });

      let functionParams =
      {
        data: JSON.stringify(params)
      };

      let ajaxParams = {};

      App.Helper.ajaxCall("page_save", functionParams, ajaxParams);
    }
  });

  $("#btnSettingsPageNew").on("click", function()
  {
    let $btn = $(this);

    let functionParams =
    {
      page_id: 0
    };

    let ajaxParams = 
    {
      sourceEl: $btn,
      effectTarget: $btn,
      onSuccess: function(response)
      {
        let $frm = $(response.content);

        let dialog = bootbox.dialog(
        {
          title: App.Lang.get('add_new_page'),
          message: $frm,
          buttons:
          {
            cancel:
            {
              label: App.Lang.get('cancel'),
              className: 'btn-secondary'
            },
            ok:
            {
              label: App.Lang.get('save'),
              className: 'btn-primary',
              callback: function(event)
              {
                var $btn = $(event.target);

                if ($frm.valid())
                {
                  var functionParams =
                  {
                    name: $frm.find("#txtModalPageName").val()
                  };

                  var ajaxParams = 
                  {
                    sourceEl: $btn,
                    effectTarget: $btn,
                    onSuccess: function()
                    {
                      dialog.modal('hide');
                      window.location.reload();
                    }
                  };

                  App.Helper.ajaxCall("page_add", functionParams, ajaxParams);
                }

                return false;
              }
            }
          }
        });
      }
    };

    App.Helper.ajaxCall("page_form", functionParams, ajaxParams);
  });

  $(".btnSettingsPageEdit").on("click", function(event)
  {
    event.preventDefault();

    let $btn = $(this);
    let page_id = $btn.parents(".trPage").first().data("id");

    let functionParams =
    {
      page_id: page_id
    };

    let ajaxParams = 
    {
      sourceEl: $btn,
      effectTarget: $btn,
      onSuccess: function(response)
      {
        let $frm = $(response.content);

        bootbox.dialog(
        {
          title: App.Lang.get('edit_page'),
          message: $frm,
          buttons:
          {
            cancel:
            {
              label: App.Lang.get('cancel'),
              className: 'btn-secondary'
            },
            ok:
            {
              label: App.Lang.get('save'),
              className: 'btn-primary',
              callback: function(event)
              {
                let $btnSave = $(event.target);

                if ($frm.valid())
                {
                  let params = {};
                  params[page_id] = {
                    "name": $frm.find("[name=name]").val()
                  };
                  
                  let functionParams =
                  {
                    data: JSON.stringify(params)
                  };

                  let ajaxParams = 
                  {
                    sourceEl: $btnSave,
                    effectTarget: $btnSave,
                    onSuccess: function()
                    {
                      window.location.reload();
                    }
                  };

                  App.Helper.ajaxCall("page_save", functionParams, ajaxParams);
                }

                return false;
              }
            }
          },
        });
      }
    };

    App.Helper.ajaxCall("page_form", functionParams, ajaxParams);
  });
  
  $(".btnSettingsPageDelete").on("click", function(event)
  {
    event.preventDefault();
    let $btn = $(this);
    
    if (confirm(App.Lang.get("confirm_delete")))
    {
      let functionParams =
      {
        page_id: $btn.parents(".trPage").first().data("id")
      };

      let ajaxParams = 
      {
        sourceEl: $btn,
        effectTarget: $btn,
        onSuccess: function()
        {
          window.location.reload();
        }
      };

      App.Helper.ajaxCall("page_delete", functionParams, ajaxParams);
    }
  });
});
